var eventListFeatured = {
  loading:false,
  dayNum:1,
  timezone:"Pacific/Honolulu", // hawaii timezone
  cacheRoot:"https://media.hubhawaii.com/events/cache/"+ELAJAX.calendarID+"/featured.cache",
  filterRegionName:false,
  filterCategoryNames:[],
  load:async function(holderID){
    this.holderID = holderID;
    this.holder = document.getElementById(holderID);
    this.holder.classList.add("eventsListFeatured");

    this.scroller = document.createElement("div");
    this.scroller.classList.add("scroller");
    this.loader = this.holder.querySelector(".featuredLoader");
    this.holder.append(this.scroller);

    this.layout();
    this.loadEvents();
  },
  layout:function(){
    
    var setOffset = () => {
      this.leftOffset = (window.innerWidth - 1200)/2;
      this.leftOffset = this.leftOffset < 0 ? 0 : this.leftOffset;
      this.scroller.style.paddingLeft = this.leftOffset + "px";
      this.scroller.style.paddingRight = this.leftOffset + "px";
      this.loader.style.paddingLeft = this.leftOffset + "px";
      this.loader.style.paddingRight = this.leftOffset + "px";
    };

    this.arrowLeft = document.createElement("div");
    this.arrowLeft.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Back</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/></svg>';
    this.arrowLeft.classList.add("arrowLeft");
    this.scroller.append(this.arrowLeft);
    this.arrowLeft.addEventListener("click",(e)=>{
      e.preventDefault();
      this.scroller.scrollTo({left:this.scroller.scrollLeft - (window.innerWidth*0.75),behavior:"smooth"});
    });

    this.arrowRight = document.createElement("div");
    this.arrowRight.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>';
    this.arrowRight.classList.add("arrowRight");
    this.arrowRight.classList.add("show");
    this.scroller.append(this.arrowRight);
    this.arrowRight.addEventListener("click",(e)=>{
      e.preventDefault();
      this.scroller.scrollTo({left:this.scroller.scrollLeft + (window.innerWidth*0.75),behavior:"smooth"});
    });

   
    
    

    window.addEventListener("resize",()=>{
      setOffset();
    });



    this.scroller.addEventListener("scroll",()=>{
      this.setArrows();
    });

    setOffset();
    this.setArrows();

  },
  setArrows:function(){
    var scrollBounds = this.scroller.getBoundingClientRect();
    var scrollX = this.scroller.scrollLeft;
    if(scrollX > this.leftOffset){
      this.arrowLeft.classList.add("show");
    }
    else{
      this.arrowLeft.classList.remove("show");
    }
    
    if(this.scroller.scrollWidth <= scrollBounds.width){
      this.arrowRight.classList.remove("show");
    }
    else if((scrollX + window.innerWidth+this.leftOffset) < this.scroller.scrollWidth){
      this.arrowRight.classList.add("show");
    }
    else{
      this.arrowRight.classList.remove("show");
    }

  },
  loadEvents:function(){
    var dateObj = new Date();
    var minuteBreaker = Math.floor(dateObj.getUTCMinutes() / 10);
    var cacheBreaker = dateObj.getUTCMonth() + "-" + dateObj.getUTCDate() + "-" + dateObj.getUTCFullYear() + "-" + dateObj.getUTCHours() + "-" + minuteBreaker;
    
    fetch(this.cacheRoot+"?v="+cacheBreaker)
    .then(res=>res.json())
    .then(data=>{
      this.loader.remove();
      this.display(data);

      if(!data || data.length === 0){
        this.holder.style.display = "none";
      }
      this.setArrows();
    }).catch(e=>{
      this.holder.style.display = "none";

    });
  },
  getClosestDate:function(dates){
    var {timestamp:todayTimestamp,day:todayDay,dateString:todayDateString,date:todayDate,week:todayWeek,month:todayMonth,year:todayYear} = this.getTodayDate();
    var closestDate = false;

    // Find Dates Happening Today
    for(let i = 0;i<dates.length;i++){
      let d = dates[i];
      if(d.repeat_day !== null){

        if(d.repeat_day >= todayDay){
          closestDate = {
            ...d,
            isToday:d.repeat_day == todayDay ? true : false,
            dateString:d.repeat_day == todayDay ? (d.startTime >= 61200000 ? "TONIGHT" : "TODAY") : d.dateString
          };
          break;
        }
      }
      else if(d.repeat_date !== null){
        if(d.repeat_date >= todayDay){
          closestDate = {
            ...d,
            isToday:d.repeat_date == todayDate ? true : false,
            dateString:d.repeat_date == todayDate ? (d.startTime >= 61200000 ? "TONIGHT" : "TODAY") : d.dateString
          };
          break;
        }

      }
      else if(d.repeat_day_week !== null){
        if(d.timestamp >= todayTimestamp){
          closestDate = {
            ...d,
            isToday:d.timestamp == todayTimestamp ? true : false,
            dateString:d.timestamp == todayTimestamp ? (d.startTime >= 61200000 ? "TONIGHT" : "TODAY") : d.dateString
          };
          break;
        }

      }
      else{
        if(d.date == todayDateString){
          closestDate = {
            ...d,
            isToday:true,
            dateString:d.startTime >= 61200000 ? "TONIGHT" : "TODAY"
          };
          break;
        }
        else if(d.timestamp > todayTimestamp){
          closestDate = {
            ...d,
            isToday:false
          };
          break;
        }
      }
    }

    if(!closestDate){
      closestDate = {
        ...dates[0],
        isToday:false
      }
    }


    return closestDate;


  },
  display:function(data){

    var {timestamp:todayTimestamp,day:todayDay,date:todayDate,week:todayWeek} = this.getTodayDate();

    // Get Valid Date Strings
    for(let i = 0; i< data.length;i++){
      data[i] = {closestDate:this.getClosestDate(data[i].dates),...data[i]};
    }

    // remove old events
    data = data.filter(d=>{
      if(d.closestDate.timestamp < todayTimestamp){
        return false;
      }
      return true;
    });


    // Randomize Order
    data = data.sort((a,b)=>{
      return Math.random() > 0.5 ? -1 : 1;
    });

    // Sort Events By Date

    data = data.sort((a,b)=>{
      var aDate = a.closestDate;
      var bDate = b.closestDate;
      var aTime = aDate.timestamp;
      var bTime = bDate.timestamp;
      return aTime == bTime ? 0 : (aTime > bTime ? 1 : -1);

    });



    // Sort Today Events to Top of List
    data = data.sort((a,b)=>{
      if(a.isToday){
        return -1;
      }
      return 1;
    });


    data.forEach(d=>{

      var itemDiv = document.createElement("a");
      itemDiv.classList.add("event");
      itemDiv.href = (ELAJAX.homeURL+"event/"+d.eventHash);
      itemDiv.setAttribute("data-region",d.region);
      itemDiv.setAttribute("data-category",d.category);

      if(this.filterRegionName && d.region !== this.filterRegionName){
        itemDiv.style.display = "none";
      }
      if(this.filterCategoryNames.length){
        var hasCategory = this.filterCategoryNames.find(c=>{
          return d.category.indexOf(c) >= 0 ? true : false;
        });
        if(!hasCategory){
          itemDiv.style.display = "none";
        }
      }

      var itemHTML = "";
      if(d.image && d.featured){
        itemHTML += '<img src="" data-nowebp="true" data-defer-image="'+d.image+'" class="eventbg"/>';
      }
      else if(d.featured){
        itemHTML += '<img data-nowebp="true" data-defer-image="'+ELAJAX.images+'defaultImage.png" class="eventbg"/>';
      }
      itemHTML += '<div class="eventHolder">';

      if(d.featured){
        itemHTML += '<div class="eventImage">';
        itemHTML += this.dateBlock(d);
        if(d.image){
          itemHTML += '<img data-nowebp="true" data-defer-image="'+d.image+'"/>';
        }
        else{
          itemHTML += '<img data-nowebp="true" data-defer-image="'+ELAJAX.images+'defaultImage.png"/>';
        }
        itemHTML += '</div>';
      }

      itemHTML += '<div class="text">';
      itemHTML += '<span class="eventTime '+(d.closestDate.isToday ? "today" : "")+'">';
      itemHTML += d.closestDate.dateString+' &middot; '+this.displayTimes(d);
      itemHTML += '</span>';
      itemHTML += '<h3>'+d.title+'</h3>';



      itemHTML += '<span class="subText"><b>'+d.region+'</b> &middot; '+d.address+'</span>';
      itemHTML += '<span class="eventTags"><span class="tag">';
      itemHTML += d.category.replace(/,/g,'</span><span class="tag">');
      itemHTML += '</span></span>';
      itemHTML += '</div>';
      itemHTML += '</div>';
      itemHTML += '</div>';
      itemDiv.innerHTML = itemHTML;
      this.scroller.append(itemDiv);
      if(d.featured){
        itemDiv.classList.add("featured");
      }

      itemDiv.addEventListener("click",(e)=>{
        e.preventDefault();
        eventList.expand(d.eventHash,e);
      })

    });

    deferImages.load();
  },
  getTodayDate:function(){
    if(this.todayDate) return this.todayDate;

    var month = moment.tz(this.timezone).format("M");
    var year = moment.tz(this.timezone).format("YYYY");
    var date = moment.tz(this.timezone).format("D");

    //month = 7;
    //date = 8;

    var dateObj = new Date(Date.UTC(year,month-1,date));
    var timestamp = dateObj.getTime();

    var day = moment.utc(timestamp).format("d");


    this.todayDate = {
      dateObj:dateObj,
      dateString:month + "-" + date + "-" + year,
      timestamp:timestamp,
      date:date,
      month:month,
      year:year,
      week:Math.ceil(date/7),
      day:parseInt(day)
    };
    return this.todayDate;
  },
  getDateString:function(dates){
    var d = this.getClosestDate(dates);
    return d;

  },
  displayTimes:function(listing){
    var {day:todayDay,dateString:todayDateString} = this.getTodayDate();
    var timeString = listing.closestDate.timeString;

    listing.dates.forEach(d=>{
      if(d.repeat_day !== null){
        if(d.repeat_day == todayDay && d.timeString !== listing.closestDate.timeString){
          timeString += " &middot; "+d.timeString;
        }
      }
      else{
        if(d.date == todayDateString && d.timeString !== listing.closestDate.timeString){
          timeString += " &middot; "+d.timeString;
        }
      }
    });
    return timeString;

  },
  dateBlock:function(event){
    var weekdays = ["Sunday","Monday","Tuesday","Weds","Thurs","Friday","Sat"];
    var months = ["Jan","Feb","Mar","Apr","May","June","July","Aug","Sep","Oct","Nov","Dec"];
    //let {day,dateString,timestamp} = this.getTodayDate();
    var d = this.getClosestDate(event.dates);

    if(d.repeat_day !== null){
      return '<div class="eventDate"><div class="eventDateHolder"><span class="day" style="line-height:1.4em;"><i>EVERY</i><br/>'+weekdays[d.repeat_day]+'</span></div></div>';
    }
    else if(d.repeat_date !== null){
      return '<div class="eventDate"><div class="eventDateHolder"><span class="day" style="line-height:1.4em;"><i>EVERY</i></span>'+this.humanize(d.repeat_date)+'<span class="day"><i>OF THE MONTH</i></span></div></div>';
    }
    else if(d.repeat_day_week !== null){
      var [eDay,eWeek] = d.repeat_day_week.split(":");
      return '<div class="eventDate"><div class="eventDateHolder"><span class="day" style="line-height:1.4em;"><i>EVERY</i></span>'+this.humanize(eWeek)+'<span class="day"><i>'+weekdays[eDay]+'</i></span></div></div>';
    }
    else{
      var eDateObj = new Date();
      eDateObj.setTime(d.timestamp);
      return '<div class="eventDate"><div class="eventDateHolder">'+eDateObj.getUTCDate()+'<span class="day">'+months[eDateObj.getUTCMonth()]+'</span></div></div>';
    }


  },
  humanize:function(number) {
    if(number % 100 >= 11 && number % 100 <= 13)
        return number + "th";

    switch(number % 10) {
        case 1: return number + "st";
        case 2: return number + "nd";
        case 3: return number + "rd";
    }

    return number + "th";
  }
};
